import React from "react";
import { useButtonStyles } from "./Button.styles";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
  buttonType?: "primary" | "secondary" | "tertiary" | "link";
  className?: string;
  disabled?: boolean;
  icon?: any;
  thin?: boolean;
  /** Required for QA testing */
  htmlId: string;
  label?: string;
  dark?: boolean;
  light?: boolean;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
}

function getMode(buttonType: string): string {
  switch (buttonType) {
    case "primary":
      return "buttonPrimary";
    case "secondary":
      return "buttonSecondary";
    case "tertiary":
      return "buttonTertiary";
    case "link":
      return "buttonLink";
    default:
      return "buttonPrimary";
  }
}

export const Button = ({
  className = "",
  buttonType = "secondary",
  htmlId,
  label,
  icon,
  thin,
  type = "button",
  ariaLabel,
  onClick,
  dark,
  light,
  ...props
}: ButtonProps) => {
  const classes = useButtonStyles({ dark, light, thin });
  return (
    <button
      className={`${className} ${classes.buttonBase} ${
        classes[getMode(buttonType)]
      }`}
      id={htmlId}
      onClick={onClick}
      {...(props as any)}
      type={type}
    >
      <span className={classes.myLabel}>
        {icon && <span className={classes.myIcon}>{icon}</span>}
        {label || props.children}
      </span>
    </button>
  );
};
